import { configureStore } from '@reduxjs/toolkit';
import devicesReducer from './slices/devicesSlice';
import filtersReducer from './slices/filtersSlice';
import uiReducer from './slices/uiSlice';
import locationsReducer from './slices/locationsSlice';
import notificationsReducer from './slices/notificationsSlice';
import authReducer from './slices/authSlice';
import adminReducer from './slices/adminSlice';
import deviceHistoryReducer from './slices/deviceHistorySlice';
import { db } from '../firebase-config';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    devices: devicesReducer,
    filters: filtersReducer,
    ui: uiReducer,
    locations: locationsReducer,
    notifications: notificationsReducer,
    admin: adminReducer,
    deviceHistory: deviceHistoryReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: [
        'devices/fetchAllDevices/fulfilled', 
        'devices/fetchAllDevices/pending', 
        'devices/fetchAllDevices/rejected',
        'locations/fetchTowerLocations/fulfilled',
        'locations/fetchBeachLocations/fulfilled',
        'locations/fetchOfficeLocations/fulfilled',
        'locations/fetchTritonLocations/fulfilled',
        'auth/loginSuccess',
        'auth/restoreSession'
      ],
      // Ignore these field paths in all actions
      ignoredActionPaths: ['meta.arg', 'payload.timestamp', 'payload.lastSeen'],
      // Ignore these paths in the state
      ignoredPaths: [
        'devices.allDevices', 
        'devices.filteredDevices', 
        'firebase', 
        'notifications.notifications',
        'locations.towerLocations',
        'locations.beachLocations', 
        'locations.officeLocations',
        'locations.tritonLocations',
        'auth.user.lastSeen',
        'auth.profile.updated_at',
        'auth.profile.created_at'
      ],
    },
    // Production optimizations
    immutableCheck: process.env.NODE_ENV !== 'production',
    thunk: {
      extraArgument: { db }
    }
  }),
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development
  // Production optimizations
  preloadedState: undefined,
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers()
});

